import { useEffect } from 'react';
import { ProductDetailsFragment } from './useProductDetailsHashSync.utils';

interface OpenProductDetailsFromFragmentParams {
  productId?: string;
  productColorId?: string;
  kitId?: string;
}

interface UseOpenProductDetailsFromFragmentParams {
  isEnabled: boolean;
  fragmentKind?: ProductDetailsFragment['kind'];
  fragmentValue?: string;
  resolvedProductId?: string;
  onOpenProductDetails: (params: OpenProductDetailsFromFragmentParams) => void;
}

const useOpenProductDetailsFromFragment = ({
  isEnabled,
  fragmentKind,
  fragmentValue,
  resolvedProductId,
  onOpenProductDetails,
}: UseOpenProductDetailsFromFragmentParams) => {
  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    if (fragmentKind === 'kit') {
      onOpenProductDetails({ kitId: fragmentValue });
      return;
    }

    if (resolvedProductId) {
      onOpenProductDetails({ productId: resolvedProductId, productColorId: fragmentValue });
    }
  }, [isEnabled, fragmentKind, fragmentValue, resolvedProductId, onOpenProductDetails]);
};

export default useOpenProductDetailsFromFragment;
